export default "__VITE_ASSET__740360e8__"